export const PRIVACY_POLICY_URL = 'https://www.digima.com/privacypolicy';
